import { useNavigate } from 'react-router';
import { WheelPageFooter } from './WheelPageFooter';
import './WheelPrize.styl';
import { routes } from 'utils/router';
import { useStoreContext } from 'store/app';
import { useTranslationsContext } from 'store/translations';
import { useEffect } from 'react';
import { QuestTypes } from 'src/types';

export const WheelPrize = () => {
    const { translate } = useTranslationsContext();
    const { revolverPrize, questsConfig, sendNotification: sendNotification14days } = useStoreContext();
    const navigate = useNavigate();

    useEffect(() => {
        if (!revolverPrize) return;
        const mission = questsConfig?.tasks.find((x) => x.key === revolverPrize?.mission_id);
        if (mission?.newYearType === QuestTypes.LOGINS || revolverPrize.renderParams.notificationKey) {
            sendNotification14days(revolverPrize);
        }
    }, [revolverPrize]);

    const onClick = () => {
        navigate(routes.main, {
            state: {
                openPresentModal: true
            }
        });
    };

    return (
        <div className="wheel-prize">
            {/* TODO: нужна заглушка картинка */}
            <img className="wheel-prize-img" src={revolverPrize?.renderParams.img ?? ''} alt="prize" />
            <WheelPageFooter
                onClick={onClick}
                title={revolverPrize?.renderParams.congrats ?? 'Подарок'}
                subtitle={revolverPrize?.renderParams.desc ?? translate('wheel.prize.subtitle')}
                providerLink={revolverPrize?.renderParams.providerLink}
                reward={revolverPrize || undefined}
                btnText={translate('wheel.prize.button')}
            />
        </div>
    );
};
